import { OperationVue } from "../operations/OperationVue";
import { container } from "@/inversify.config";
import IOperationService from "../../services/operations/IOperationService";
import { DiTokens } from "../../services/diTokens";
import { RecoveryModel } from "../../models/auth/RecoveryModel";

/**Модель представления восстановления доступа*/
export class RecoveryVue extends OperationVue {
  /**Признак отображения кода подтверждения */
  showConfirmCode: boolean = false;


  /**Инициализация операции */
  async initOperation(): Promise<void> {
    this.loading = true;
    this.service = container.get<IOperationService>(DiTokens.RecoveryService);
    this.OperationModel = (await this.service.init()) as RecoveryModel;
    this.loading = false;
  }

  /**Метод для выполнения после успешного проведения */
  async afterExecute(): Promise<void> {
    this.$router.push(`/login`);
  }
}
